module.exports = __webpack_public_path__ + "static/sample_Worksheet-7f173f488e77ce93967de0ac064b33a0.png";